export const SET_COUNTRIES = 'countries/SET_COUNTRIES';
